/* global atob fetch */
/*
 * actions.js 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */

/* global localStorage */

import {
    ACTIVE_FILTER,
    ACTIVE_PARTICIPANT_SORT,
    CLOSE_SURVEY_DIALOG,
    IMPRINT_DIALOG_VISIBLE,
    LOGIN_SUCCEEDED,
    LOGOUT,
    SAVE_SHOW_SURVEY_DIALOG,
    SELECT_PARTICIPANT,
    UPDATE_PARTICIPANT_LIST
} from './types';

export const activateFilter = filter => ({
    type: ACTIVE_FILTER,
    filter
});

export const showImprintDialog = () => ({
    type: IMPRINT_DIALOG_VISIBLE,
    open: true
});

export const hideImprintDialog = () => ({
    type: IMPRINT_DIALOG_VISIBLE,
    open: false
});

export const changeSort = by => ({
    type: ACTIVE_PARTICIPANT_SORT,
    by
});

export const selectParticipant = participant => ({
    type: SELECT_PARTICIPANT,
    participant
});

export const updateParticipantList = list => ({
    type: UPDATE_PARTICIPANT_LIST,
    list
});

const loginSuccess = user => ({
    type: LOGIN_SUCCEEDED,
    user
});

const logout = () => ({
    type: LOGOUT
});

/**
 * Hilfsfunktion, die beim Einloggen eines Benutzers aufgerufen wird.
 *
 * @param {Function} dispatch - Die dispatch-Funktion von Redux; ermöglicht asynchrones Action-Handling
 * @param {Object}   jwt      - Das frisch von stepnova bezogene JWT des Benutzers
 */
const handleUserLogin = (dispatch, jwt) => {
    localStorage.setItem('token', jwt.token);

    const user = jwt.token.split('.').slice(1, 2).map(atob).map(JSON.parse)[0];

    dispatch(loginSuccess(user));
};

/**
 * Hilfsfunktion, die beim Ausloggen eines Benutzers aufgerufen wird.
 *
 * @param {Function} dispatch Die dispatch-Funktion von Redux; ermöglicht asynchrones Action-Handling
 */
const handleUserLogout = dispatch => {
    localStorage.removeItem('token');

    dispatch(logout());
};

/**
 * Stepnova stellt immer wenn ein Benutzer eingeloggt ist ein JWT aus. Diese Methode verifiziert, ob der entsrpechende Benutzer auch tatsächlich aufgrund seiner Rolle, Standort
 * etc. autorisiert ist den Bildungsmanager zu benutzen. Dazu wird ein Request zur Verifikation zu Stepnova geschickt. Erst wenn von dort das OK kommt, wird der Benutzer
 * eingeloggt.
 *
 * @param {function} dispatch Die dispatch-Funktion ermöglicht asynchrones Action-Handling
 * @param {Object} jwt der JWT-Token-Wrapper der neben dem Token auch die Expiry-Date etc. beinhaltet
 * @return {Promise} Stets erfülltes Promise. Ermöglicht es nach Login/Logout des Benutzers weitere Aktionen zu triggern.
 */
const verifyLogin = (dispatch, jwt) => {

    if (!jwt) {
        handleUserLogout(dispatch);
        return null;
    }

    // eslint-disable-next-line no-process-env
    return fetch(`${process.env.BILDUNGSMANAGER_VERIFICATION_URL}?code=gui.menu.bildungsmanager`, {
        mode: 'cors',
        credentials: 'include'
    }).then(res => {
        if (res.ok) {
            return handleUserLogin(dispatch, jwt);
        }

        return handleUserLogout(dispatch);

    }).catch(() => {
        handleUserLogout(dispatch);
    });
};

/**
 * Bezieht ein Token von Stepnova. Wurde ein Token zurückgegeben, bedeutet das nur, dass der Benutzer in Stepnova eingeloggt ist. Deshalb wird im Erfolgsfall eine Verifikation
 * durchgeführt, ob der Benutzer auch tatsächlich autorisiert ist. Erst dann wird der Benutzer auch im Bildugnsmanager eingeloggt.
 * Im Fehlerfall, wird der Benutzer ausgeloggt.
 *
 * @param {function} dispatch Die dispatch-Funktion ermöglicht asynchrones Action-Handling
 */
// eslint-disable-next-line no-process-env
const fetchToken = dispatch => fetch(process.env.BILDUNGSMANAGER_TOKEN_URL, {
    mode: 'cors',
    credentials: 'include'
})
    .then(response => response.ok ? response.json() : '')
    .then(json => verifyLogin(dispatch, json))
    .catch(() => {
        handleUserLogout(dispatch);
    });

export const refreshLogin = () => dispatch => fetchToken(dispatch);

const saveAndShowSurvey = json => ({
    type: SAVE_SHOW_SURVEY_DIALOG,
    lastFetchedAndShown: new Date(),
    webLink: json[0].webLink,
    description: json[0].description
});

const emptyFuntion = () => {
    // An empty function to give to the promise.
};

// eslint-disable-next-line no-process-env
const workSurvey = dispatch => fetch(`${process.env.BILDUNGSMANAGER_SURVEYMANAGER_API_URL}loadAllSurveyValidSpecific?application=biman`)
    .then(response => response.ok ? response.json() : '')
    .then(json => {
        if (json && Array.isArray(json)) {
            dispatch(saveAndShowSurvey(json));
        } else {
            emptyFuntion();
        }
    }).catch(() => {
        emptyFuntion();
    });

export const workTheSurvey = () => dispatch => workSurvey(dispatch);

export const closeSurveyDialog = () => ({
    type: CLOSE_SURVEY_DIALOG,
    open: false
});





// WEBPACK FOOTER //
// ./src/de/ergovia/actions/actions.js